import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tokenizedFormSubmit"]

  submitToken(e) {
    if (this.hasTokenizedFormSubmitTarget) {
      e.preventDefault()
      this.tokenizedFormSubmitTarget.click()
    }
  }
}
